export default __webpack_public_path__ + "static/media/grey-circle-tick.628e6845.svg";